import { api } from '@/api/queries/base';
import { ApiPath } from '@/common/app/api-path';
import {
  type BingoClaimRatingPrizeResponse,
  type BingoEventResponse,
  type BingoLeaderboardResponse,
  type BingoPurchaseRequest,
  type BingoPurchaseResponse,
  type BingoSpinResponse,
  type BingoSuperRewardResponse,
} from '@/common/types/bingo';

const bingoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBingoEvent: builder.query<BingoEventResponse, void>({
      query: () => ApiPath.BINGO_EVENT,
      keepUnusedDataFor: 0,
    }),
    bingoSpin: builder.mutation<BingoSpinResponse, { count: number }>({
      query: ({ count }) => ({
        url: ApiPath.BINGO_SPIN,
        method: 'POST',
        body: { count },
      }),
    }),
    bingoSuperReward: builder.mutation<
      BingoSuperRewardResponse,
      { optionIndex: number }
    >({
      query: ({ optionIndex }) => ({
        url: ApiPath.BINGO_SUPER_REWARD,
        method: 'POST',
        body: { optionIndex },
      }),
    }),
    bingoPurchase: builder.mutation<
      BingoPurchaseResponse,
      BingoPurchaseRequest
    >({
      query: (body) => ({
        url: ApiPath.BINGO_PURCHASE,
        method: 'POST',
        body,
      }),
    }),
    getBingoLeaderboard: builder.query<BingoLeaderboardResponse, void>({
      query: () => ApiPath.BINGO_LEADERBOARD,
      keepUnusedDataFor: 60,
    }),
    claimBingoRatingPrize: builder.mutation<
      BingoClaimRatingPrizeResponse,
      void
    >({
      query: () => ({
        url: ApiPath.BINGO_CLAIM_RATING_PRIZE,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBingoEventQuery,
  useLazyGetBingoEventQuery,
  useBingoSpinMutation,
  useBingoSuperRewardMutation,
  useBingoPurchaseMutation,
  useGetBingoLeaderboardQuery,
  useClaimBingoRatingPrizeMutation,
} = bingoApi;
